import React from 'react'
import clsx from 'clsx'
import { useStyles } from './styles'

interface Button {
    children: React.ReactNode
    type?: 'submit' | 'reset' | 'button'
    disabled?: boolean
    maskType?: 'primary' | 'secondary'
    fullWidth?: boolean
    id?: string
    className?: string
}

const Button: React.FC<Button> = ({
    children,
    type = 'button',
    disabled = false,
    maskType = 'primary',
    fullWidth = false,
    id,
    className,
}) => {
    const classes = useStyles()
    return (
        <button
            type={type}
            className={clsx(
                classes.btn,
                classes[disabled ? 'disabled' : maskType],
                fullWidth && classes.fullWidth,
                className,
            )}
            disabled={disabled}
            id={id}
        >
            {children}
        </button>
    )
}

export default React.memo(Button)
